import styled from "styled-components";
export const TimerContainer = styled.div`
  z-index: 100;
  position: absolute;
  height: 38px;
  top: 5px;

  cursor: pointer;
  border-radius: 24px;

  display: flex;
  align-items: center;


 
  div {
    &.arrow_cond {
      cursor: auto;
      pointer-events: none;
      z-index: -500;
      path {
        stroke-dasharray: 3;
      }
    }
  }
`;
export const Content = styled.div`
  display: flex;
  align-items: center;
  border-radius: 24px;
  background-color: ${({ status }) =>
    status === "done"
      ? "#49B446"
      : status === "late"
        ? "#D93333"
        : status === "doing"
          ? "#EACB29"
          : status === "pending"
            ? "#D4D6DA"
            : "#49b446"};

  width: 100%;
  height: 100%;

  border: ${({ status }) =>
    status === "doneLate" ? "2px solid #D93333" : "2px solid transparent"};

  span {
    margin-left: 10px;
    color: ${({ status }) =>
    (status === "done") | (status === "late") | (status === "doneLate")
      ? "#fff"
      : "#212326"};
    font-weight: 600;
  }
  text-overflow: ellipsis;    
  white-space: nowrap;       /* Prevent text from wrapping */
  overflow: hidden;          /* Hide any overflowing content */
`;

export const Avatar = styled.div`
  width: 25px;
  height: 25px;
  border: 1px solid #111;
  border-radius: 50%;
`;

export const Anchor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 100%;
  margin-left: 10px;
`;
